


















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Dropdown, {
  DropdownOption,
} from '@/main-components/pre-collections-new/Dropdown.vue';
import { getAllSubjects } from '@/utils/add-question/add-question-util';
import { Subject } from '@/resource/subject/subject.model';
import getLevelsBySubjectType from '@/utils/common/get-levels-by-subject-type';
import getLevel from '@/utils/common/get-level';
import { OnSubmitInput } from '@/main-components/common/Form.vue';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';

export interface DropdownSubjectValue {
  selectedSubject: string | null; // NOTE: subject UUID
  selectedForm: number | number[] | null; // NOTE: form prefix
  selectedChapter: number | null; // NOTE: chapter ID
  selectedChapters: number[]; // NOTE: chapter IDs array
}

@Component({
  components: { Dropdown },
})
export default class DropdownSubject extends Vue {
  @Prop({ required: true })
  queries: PreCollectionsParams;

  @Prop({ required: true })
  name: string;

  @Prop({ default: null })
  initialValue: DropdownSubjectValue | null;

  @Prop({ default: false })
  isRequired: boolean;

  @Prop({ default: false })
  isFormRequired: boolean;

  @Prop({ default: false })
  isChapterRequired: boolean;

  @Prop({ default: false })
  isHideForm: boolean;

  @Prop({ default: false })
  isHideChapter: boolean;

  @Prop({ default: false })
  isInline: boolean;

  @Prop({ default: false })
  showLabel: boolean;

  @Prop({ default: false })
  dropdownOptionsWidth: string | boolean;

  // NOTE: To toggle multi select or single select for chapter
  @Prop({ default: false })
  isSingleChapter: boolean;

  availSubjects: Subject[] = [];
  // NOTE: hold all information of subject, forms and chapters
  selectedAvailSubject: Subject | null = null;

  subjectOptions: DropdownOption[] = [];
  selectedSubject: DropdownOption | null = null;

  formOptions: DropdownOption[] = [];
  selectedForm: DropdownOption | null = null;

  chapterOptions: DropdownOption[] = [];
  selectedChapter: DropdownOption | null = null;

  chaptersOptions: DropdownOption[] = [];
  selectedChapters: DropdownOption[] = [];

  subjectError: string | boolean = false;
  formError: string | boolean = false;
  chapterError: string | boolean = false;
  chaptersError: string | boolean = false;

  isLoading = true;

  async created() {
    this.$emit('updateIsFormLoading', true);

    this.availSubjects = await getAllSubjects();
    this.initSubjects();

    this.isLoading = false;

    this.$emit('addSubmitInput', this.submitInput);
    this.$emit('updateIsFormLoading', false);
  }

  onSubjectOptionClicked(option: DropdownOption) {
    this.selectedSubject = option;
    this.reinitSelectedAvailSubject();
    this.initForms();
  }

  onFormOptionClicked(option: DropdownOption) {
    this.selectedForm = option;
    this.queries.levels =
      this.selectedForm.value === 999
        ? []
        : [this.selectedForm.value as number];
    this.initChapter();
    this.initChapters();
  }

  onChapterOptionClicked(options: DropdownOption) {
    this.selectedChapter = options;
  }

  onChaptersOptionClicked(options: DropdownOption[]) {
    this.selectedChapters = options;
  }

  initSubjects() {
    // NOTE: Initialize subject dropdown options
    this.subjectOptions = this.availSubjects.map(availSubject => {
      let isSelected = false;

      const initialSelectedSubject = this.queries.subjectUuid;

      // NOTE: Initial selected option for subject
      if (availSubject.uuid === initialSelectedSubject) {
        isSelected = true;
        this.selectedSubject = {
          value: availSubject.uuid,
          text: availSubject.name,
          isSelected: isSelected,
        };

        this.selectedAvailSubject = availSubject;

        this.queries.subjectUuid = this.selectedAvailSubject.uuid;

        this.initForms();
      }

      return {
        value: availSubject.uuid,
        text: availSubject.name,
        isSelected: isSelected,
      };
    });

    // To initiate All Subjects option
    if (this.queries.subjectUuid === 'all') {
      this.subjectOptions.unshift({
        value: 'all',
        text: 'Semua Subjek',
        isSelected: true,
      });

      this.selectedSubject = {
        value: 'all',
        text: 'Semua Subjek',
        isSelected: true,
      };

      // Since All Subjects dont have any properties, we used the first availSubjects properties so we are able to initForms
      this.selectedAvailSubject = this.availSubjects[0];

      this.initForms();
    } else {
      this.subjectOptions.unshift({
        value: 'all',
        text: 'Semua Subjek',
        isSelected: false,
      });
    }
  }

  reinitSelectedAvailSubject() {
    // NOTE: Triggered when user select new subject
    // NOTE: To get all new data options for form and chapter
    if (this.selectedSubject) {
      const selectedAvailSubject = this.availSubjects.find(
        availSubject => availSubject.uuid === this.selectedSubject?.value,
      );

      if (selectedAvailSubject) {
        this.selectedAvailSubject = selectedAvailSubject;
        this.queries.subjectUuid = this.selectedAvailSubject.uuid;
      } else {
        this.queries.subjectUuid = 'all';
      }
    }
  }

  initForms() {
    // NOTE: Initialize form dropdown options
    if (this.selectedAvailSubject) {
      this.formOptions = [];
      this.selectedForm = null;

      this.chapterOptions = [];
      this.selectedChapter = null;

      this.chaptersOptions = [];
      this.selectedChapters = [];

      const initialSelectedForm = this.initialValue?.selectedForm;

      // To create 'All Forms' options in the dropdown
      // ---------------------------------------------------
      if (
        initialSelectedForm === 999 ||
        (initialSelectedForm &&
          Array.isArray(initialSelectedForm) &&
          !initialSelectedForm.length)
      ) {
        const isSelected = true;

        this.formOptions.push({
          value: 999,
          text: 'Semua Tahap',
          isSelected,
        });

        this.selectedForm = {
          value: 999,
          text: 'Semua Tahap',
          isSelected,
        };
      } else {
        const isSelected = false;

        this.formOptions.push({
          value: 999,
          text: 'Semua Tahap',
          isSelected,
        });
      }
      //------------------------------------------------

      // To create SPM, PT3, Tahap 1 and Tahap 2 in the options
      // ------------------------------------------------
      // const extraForms = [-4, -3, -2, -1];
      const extraForms = [-4, -2, -1];

      extraForms.map(form => {
        const level = getLevelPremadePaper(form);
        let isSelected = false;

        if (initialSelectedForm && initialSelectedForm[0] === form) {
          isSelected = true;
          this.selectedForm = {
            value: form,
            text: level,
            isSelected,
          };
        }

        this.formOptions.push({
          value: form,
          text: level,
          isSelected,
        });
      });
      // ------------------------------------------------

      this.selectedAvailSubject.subjectTypes.forEach(subjectType => {
        const forms = getLevelsBySubjectType(subjectType, false);

        forms.forEach(form => {
          const level = getLevel(form);
          let isSelected = false;

          if (initialSelectedForm && initialSelectedForm[0] === form) {
            isSelected = true;
            this.selectedForm = {
              value: form,
              text: level,
              isSelected,
            };
          }

          this.formOptions.push({
            value: form,
            text: level,
            isSelected,
          });
        });
      });

      this.initChapter();
    }
  }

  initChapter() {
    // NOTE: Initialize chapter dropdown options
    this.chapterOptions = [];
    this.selectedChapter = null;

    if (this.selectedAvailSubject && this.selectedForm) {
      const initialSelectedChapter = this.initialValue?.selectedChapter;

      this.selectedAvailSubject.chapters.forEach(chapter => {
        if (this.selectedForm && chapter.form === this.selectedForm.value) {
          let isSelected = false;

          const chapterNumber = this.selectedAvailSubject?.isNoLevel
            ? ''
            : `Chapter ${chapter.prefix}: `;

          if (initialSelectedChapter && initialSelectedChapter === chapter.id) {
            isSelected = true;

            this.selectedChapter = {
              value: chapter.id, // NOTE: set value as chapter ID for API
              text: chapterNumber + chapter.name,
              isSelected: false,
            };
          }

          this.chapterOptions.push({
            value: chapter.id, // NOTE: set value as chapter ID for API
            text: chapterNumber + chapter.name,
            isSelected,
          });
        }
      });
    }
  }

  initChapters() {
    // NOTE: Initialize chapters dropdown options
    this.chaptersOptions = [];
    this.selectedChapters = [];

    if (this.selectedAvailSubject && this.selectedForm) {
      this.selectedAvailSubject.chapters.forEach(chapter => {
        if (this.selectedForm && chapter.form === this.selectedForm.value) {
          const chapterNumber = this.selectedAvailSubject?.isNoLevel
            ? ''
            : `Chapter ${chapter.prefix}: `;

          this.chaptersOptions.push({
            value: chapter.id, // NOTE: set value as chapter ID for API
            text: chapterNumber + chapter.name,
            isSelected: false,
          });
        }
      });
    }
  }

  submitInput(): OnSubmitInput {
    let hasError = false;

    if (this.isRequired && !this.selectedSubject) {
      hasError = true;
      this.subjectError = 'Subject cannot be empty';
    } else {
      this.subjectError = false;
    }

    if (this.isFormRequired && !this.selectedForm) {
      hasError = true;
      this.formError = 'Form cannot be empty';
    } else {
      this.formError = false;
    }

    if (this.isChapterRequired) {
      if (this.isSingleChapter && !this.selectedChapter) {
        hasError = true;
        this.chapterError = 'Chapter cannot be empty';
      } else if (!this.isSingleChapter && !this.selectedChapters.length) {
        hasError = true;
        this.chaptersError = 'Chapter cannot be empty';
      } else {
        this.chapterError = false;
        this.chaptersError = false;
      }
    } else {
      this.chapterError = false;
      this.chaptersError = false;
    }

    return {
      hasError,
      value: {
        selectedSubject: this.selectedSubject
          ? (this.selectedSubject.value as string)
          : null,
        selectedForm: this.selectedForm
          ? (this.selectedForm.value as number)
          : null,
        selectedChapter: this.selectedChapter
          ? (this.selectedChapter.value as number)
          : null,
        selectedChapters: this.selectedChapters
          ? this.selectedChapters.map(
              selectedChapter => selectedChapter.value as number,
            )
          : [],
      },
      name: this.name,
    };
  }

  @Watch('queries.subjectUuid')
  @Watch('queries.level')
  updateDropdown() {
    this.initSubjects();
  }
}
